import * as types from './stockActionTypes';

export const getStockRequest = (payload) => 
({ type: types.GET_STOCK_REQUEST, payload });
export const getStockSuccess = (payload) => 
({ type: types.GET_STOCK_SUCCESS, payload });
export const getStockError = (payload) => 
({ type: types.GET_STOCK_ERROR, payload });

export const addStockRequest = (payload) => 
({ type: types.ADD_STOCK_REQUEST, payload });
export const addStockSuccess = (payload) => 
({ type: types.ADD_STOCK_SUCCESS, payload });
export const addStockError = (payload) => 
({ type: types.ADD_STOCK_ERROR, payload });

export const updateStockRequest = (payload) => 
({ type: types.UPDATE_STOCK_REQUEST, payload });
export const updateStockSuccess = (payload) => 
({ type: types.UPDATE_STOCK_SUCCESS, payload });
export const updateStockError = (payload) => 
({ type: types.UPDATE_STOCK_ERROR, payload });

export const deleteStockRequest = (payload) => 
({ type: types.DELETE_STOCK_REQUEST, payload });
export const deleteStockSuccess = (payload) => 
({ type: types.DELETE_STOCK_SUCCESS, payload });
export const deleteStockError = (payload) => 
({ type: types.DELETE_STOCK_ERROR, payload }); 